import { axios } from '@/services/axios';

/**
 * One page of a company's call detail records between two UTC timestamps
 * (yyyy-MM-ddTHH:mm:ssZ). Resolves to `{ total, limit, callDetailRecords }`.
 */
const getCallDetailRecords = async ({
    companyId,
    from,
    to,
    page = 0,
    limit = 1,
}) => {
    const res = await axios.get(
        `/calldetailrecords/${companyId}/${encodeURIComponent(from)}/${encodeURIComponent(to)}`,
        { params: { page, limit } },
    );

    return res.data;
};

export default getCallDetailRecords;
